import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { EquipmentCategoryService } from '@app/api/api';
import { environment } from 'environments/environment';

@Component({
  selector: 'meu-modal-equipment-category',
  templateUrl: './modal-equipment-category.component.html',
  styleUrls: ['./modal-equipment-category.component.scss'],
})
export class ModalEquipmentCategoryComponent implements OnInit {
  isEdit: boolean = false;
  hasFormErrors: boolean = false;
  host: string = environment.backendhost;

  selectedFile: File | null = null;
  previewUrl: string | null = null;
  currentImage: string | null = null;

  categoryForm = new FormGroup({
    code: new FormControl('', [Validators.required, Validators.pattern('^(?!\\s*$).+')]),
    name: new FormControl('', [Validators.required, Validators.pattern('^(?!\\s*$).+')]),
    name_en: new FormControl(''),
    description: new FormControl(''),
  });

  constructor(
    public dialogRef: MatDialogRef<ModalEquipmentCategoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id: string | number | null },
    private equipmentCategoryService: EquipmentCategoryService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    if (this.data.id != null) {
      this.isEdit = true;
      this.getById(this.data.id);
    }
  }

  getById(id: string | number) {
    this.equipmentCategoryService.apiEquipmentCategoriesIdGet(String(id)).subscribe((res) => {
      if (res.success) {
        this.categoryForm.patchValue({
          code: res.data.code,
          name: res.data.name,
          name_en: res.data.name_en,
          description: res.data.description,
        });
        this.currentImage = res.data.image || res.data.icon || res.data.default_image || null;
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  onFileSelected(event: any) {
    const file: File = event.target.files && event.target.files[0];
    if (file) {
      this.selectedFile = file;
      const reader = new FileReader();
      reader.onload = () => {
        this.previewUrl = reader.result as string;
        this.changeDetectorRef.detectChanges();
      };
      reader.readAsDataURL(file);
    }
  }

  removeImage() {
    this.selectedFile = null;
    this.previewUrl = null;
  }

  private uploadImageThenClose(id: string, type: 'create' | 'edit') {
    const categoryData = { id: id, name: this.categoryForm.value.name, code: this.categoryForm.value.code };
    if (!this.selectedFile) {
      this.dialogRef.close({ event: true, type, category: type === 'create' ? categoryData : null });
      return;
    }
    this.equipmentCategoryService.apiEquipmentCategoriesIdImagePut(id, this.selectedFile).subscribe(
      () => {
        this.dialogRef.close({ event: true, type, category: type === 'create' ? categoryData : null });
      },
      () => {
        this.dialogRef.close({ event: true, type, category: type === 'create' ? categoryData : null });
      }
    );
  }

  save() {
    this.hasFormErrors = true;
    const controls = this.categoryForm.controls;
    if (this.categoryForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }

    const payload = this.categoryForm.value;

    if (!this.isEdit) {
      this.equipmentCategoryService.apiEquipmentCategoriesPost(payload).subscribe((res) => {
        if (res.success) {
          const newId = res.data && res.data.id ? res.data.id : null;
          if (newId) {
            this.uploadImageThenClose(String(newId), 'create');
          } else {
            this.dialogRef.close({ event: true, type: 'create', category: { id: null, name: this.categoryForm.value.name, code: this.categoryForm.value.code } });
          }
        } else {
          this.dialogRef.close({ event: false, message: res.message });
        }
      });
    } else {
      this.equipmentCategoryService
        .apiEquipmentCategoriesIdPut(String(this.data.id), payload)
        .subscribe((res) => {
          if (res.success) {
            this.uploadImageThenClose(String(this.data.id), 'edit');
          } else {
            this.dialogRef.close({ event: false, message: res.message });
          }
        });
    }
  }

  closeModal() {
    this.dialogRef.close();
  }
}
